import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PartnerWizardComponent } from '../../cwc-partner-wizard';

/**
 * Definition of  parameters that the template needs to work.
 */
interface PartnerWizardPartnersTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: PartnerWizardComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const PartnerWizardPartnersTemplate: FunctionalComponent<PartnerWizardPartnersTemplateProps> = ({ controller }) => (
  <div class="partners">
    <div class="partners-grid">
      {controller.wizardData.tradingPartners?.map((partner) => (
        <button
          key={partner.tpAccountId}
          title={partner.tpName}
          onClick={async () => {
            await controller.setStep('channels', partner.tpAccountId);
            controller.onPartnerSelected.emit({
              keyAccount: partner.tpAccountId,
            });
          }}
          class="partners-button"
        >
          <img src={partner.tpImage} alt={partner.tpImageAlt} />
        </button>
      ))}
    </div>

    {controller.hrefMorePartnersButton && controller.textMorePartnersButton && (
      <div class="more-partners">
        <a href={controller.hrefMorePartnersButton}>{controller.textMorePartnersButton}</a>
      </div>
    )}
  </div>
);

export default PartnerWizardPartnersTemplate;
